// src/auth/token.ts
export function getToken()  {
  return localStorage.getItem('apiKey');
}

export function decodeJwt(token) {
  try {
    const [, payload] = token.split('.');
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}

export function isExpired(token, skewMs = 0) {
  const payload = decodeJwt(token);
  if (!payload?.exp) return true; // no exp → treat as expired
  const now = Date.now();
  return now >= payload.exp * 1000 - skewMs;
}

